/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Column, Row } from "components/styles";
import CustomButton from "components/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";

const Footer = ({
    isUpdate, formHandler: {
        form, errors
    },
    saveChanges, openDialogConfirmDelete,
    getDisabledSaveButton
}) => {
    const navigate = useNavigate();
    //#region States
    const [disabledSaveButton, setDisabledSaveButton] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        setDisabledSaveButton(getDisabledSaveButton());
    }, [form.value, errors.value]);
    //#endregion
    //#region Functions
    const cancelUpdate = () => {
        navigate(ABSOLUTE_PATHS.SETTINGS_SPACE_ADMIN_CAMPUS_SPACES);
    }
    //#endregion
    return (
        <Column align="flex-end" gap="10px">
            <Row width="100%">
                <Row>
                    <CustomButton 
                        size="medium"
                        variant="quintinary"
                        text="Cancelar"
                        onClick={cancelUpdate}/>
                    {isUpdate &&
                    <CustomButton 
                        size="medium"
                        variant="terciary"
                        text="Eliminar"
                        onClick={openDialogConfirmDelete}/>}
                </Row>
                <CustomButton 
                    size="medium"
                    text="Guardar"
                    onClick={saveChanges}
                    disabled={disabledSaveButton}/>
            </Row>
        </Column>
    );
}

export default Footer;